'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SelectGroup = require('./SelectGroup');

Object.defineProperty(exports, 'SelectGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SelectGroup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/selectGroup/index.js
// module id = 602
// module chunks = 0